import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_21: FaireProductEntity = {
  token: "legacy_prod_abbott-21",
  type: "product",
  name: "Peony Pink",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/72968c55205550913b30fe303c690ada6a7b23cfe7e5b798687270fd81598bdc.jpeg",
  priceDollars: 24,
  subcategory: "Decorative Objects",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_home-accents"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
